import axios from '@axios'
import { storePagination } from '@/mixins/store'
import { sorting } from '@/mixins'
import maintain from './reconciliation-maintain'

const getInitialState = () => ({
  ...storePagination.state(),
  filters: {
    storeId: null,
    checkingAccountId: null,
    status: undefined,
    movementDate: {
      startDate: null,
      endDate: null,
    },
  },
  conciliations: [],
})

export default {
  namespaced: true,
  state: getInitialState(),

  modules: { maintain },

  getters: {

  },

  mutations: {
    ...storePagination.mutations,

    SET_CONCILIATIONS(state, conciliations) {
      state.conciliations = conciliations
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },

    CLEAN_STATE(state) {
      const { filters, paging, conciliations, selectedInstallments } = getInitialState()
      state.filters = filters
      state.conciliations = conciliations
      state.selectedInstallments = selectedInstallments
      state.paging = paging
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchConciliations({ commit, state }) {
      const { storeId, checkingAccountId, status, movementDate } = state.filters

      const { startDate, endDate } = movementDate

      const params = {
        storeId,
        checkingAccountId,
        status,
        movementDateFrom: startDate,
        movementDateTo: endDate,
        sortBy: sorting.methods.getSorting(state),
        pageSize: state.paging.pageSize,
        pageIndex: state.paging.currentPage - 1,
      }

      if (!status) delete params.status

      const { data } = await axios.get('/api/financial/reconciliation/santander/pix', {
        params,
      })

      commit('SET_CONCILIATIONS', data.results)
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount || 0,
        rowsInCurrentPage: data.rowsInCurrentPage || 0,
      })
    },

    setFilters({ commit }, filters) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', filters)
    },

    resetFilters({ commit }) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', getInitialState().filters)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
